module.exports = __webpack_public_path__ + "img/Zaawink-blue-text.457b03ea.png";